import { Icons } from "@Assets/SvgIcons";
import React from "react";
import { useTranslation } from "react-i18next";
import './UndoToast.scss';

export type UndoToastProps = {
  text: string;
  onUndo: () => void;
  closeToast?: () => void;
}

const UndoToast = ({ text, onUndo, closeToast }: UndoToastProps) => {
  const { t } = useTranslation();
  const handleClick = () => {
    onUndo();
    closeToast && closeToast();
  };

  return (
    <div className="undo-toast">
      <div className="undo-toast__icon">
        <Icons.CheckIcon />
      </div>
      <div className="undo-toast__content">
        {text} <button onClick={handleClick}>{ t('commons.undo') }</button>
      </div>
    </div>
  );
};

export default UndoToast;
